export default function prompt() {}
